import React from 'react'
import { H2, H3, BodyCopy } from '@components/Globals'
import { Column } from '@components/Common'
import { StyledEventButton } from '@components/Button/style'
import {
  generateRandomKey,
  nodeLocaleToEnglishLanguage,
  formatPhoneNumber,
} from '@utils'
import { StyledALink } from '../style'
import {
  ContactLink,
  ProfileNameNoLink,
  StyledProfileCardGrid,
  StyledProfileDetails,
} from '@components/Card/style'
import { useLocale } from '@hooks'

const NewsStaffColumn = ({ department, title, email, phone, name, office }) => {
  return (
    <>
      <StyledProfileCardGrid padding="20px 0px 0px 0px" height="100%">
        <StyledProfileDetails>
          <BodyCopy marginBottom="5px" fontSize={16}>
            {department || title}
          </BodyCopy>
          <ProfileNameNoLink>{name}</ProfileNameNoLink>
          {email && (
            <ContactLink fontSize="16px" href={`mailto:${email}`}>
              Email
            </ContactLink>
          )}
          {phone && (
            <ContactLink
              color="default"
              fontSize="16px"
              href={`tel:${formatPhoneNumber(phone, office)}`}
            >
              {formatPhoneNumber(phone, office)}
            </ContactLink>
          )}
        </StyledProfileDetails>
      </StyledProfileCardGrid>
    </>
  )
}

const SidebarContent = ({
  preview,
  associatedPracticeAreas,
  subscribeLink,
  previewParent,
  mediaContacts,
  translation,
}) => {
  let practiceAreas
  if (preview) {
    practiceAreas = preview?.associatedPracticeAreasCollection?.items
  } else {
    practiceAreas = associatedPracticeAreas
  }
  const { locale } = useLocale()

  const localizedPracticeAreas =
    practiceAreas?.length > 0 &&
    practiceAreas.filter(
      i =>
        !i.displayOnSites ||
        (i.displayOnSites &&
          i.displayOnSites.includes(nodeLocaleToEnglishLanguage[locale]))
    )

  subscribeLink = previewParent?.subscribeLink || subscribeLink

  return (
    <Column className="max-w-135 w-full my-5 mx-auto md:w-[26%] md:mt-[55px] md:ml-10 xl:ml-[8.3%]">
      {localizedPracticeAreas?.length > 0 && (
        <>
          <H3 marginBottom={12} fontSize="14px" color="gray">
            Practice Areas
          </H3>
          {localizedPracticeAreas.map(p => (
            <BodyCopy key={p.id}>
              <StyledALink to={p?.slug} contentType={'ContentfulPracticeArea'}>
                {p.title}
              </StyledALink>
            </BodyCopy>
          ))}
          <br />
        </>
      )}
      {subscribeLink && (
        <>
          <H2
            marginTop={40}
            fontSize="30px"
            lineHeight="36px"
            normalCase
            marginBottom={20}
          >
            SIGN UP FOR NEWS INSIGHTS
          </H2>
          <StyledEventButton
            width="250px"
            height="62px"
            marginBottom="10px"
            onClick={() => {
              if (typeof window !== 'undefined') {
                window.open(subscribeLink)
              }
            }}
            active
          >
            {`Subscribe to News`}
          </StyledEventButton>
        </>
      )}
      {mediaContacts && (
        <Column>
          <H2 fontSize="1rem" marginTop={30}>
            {translation}
          </H2>
          {mediaContacts.map(p => (
            <NewsStaffColumn key={generateRandomKey()} {...p} />
          ))}
        </Column>
      )}
    </Column>
  )
}

export default SidebarContent
